var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.66667H27M6.77778 1V3.88889M21.2222 1V3.88889M5.33333 14H8.22222M12.5556 14H15.4444M19.7778 14H22.6667M5.33333 18.3333H8.22222M12.5556 18.3333H15.4444M19.7778 18.3333H22.6667M5.33333 22.6667H8.22222M12.5556 22.6667H15.4444M19.7778 22.6667H22.6667M5.62222 27H22.3778C23.9957 27 24.8047 27 25.4227 26.6851C25.9662 26.4082 26.4082 25.9662 26.6851 25.4227C27 24.8047 27 23.9957 27 22.3778V8.51111C27 6.89317 27 6.08421 26.6851 5.46625C26.4082 4.92266 25.9662 4.48072 25.4227 4.20376C24.8047 3.88889 23.9957 3.88889 22.3778 3.88889H5.62222C4.0043 3.88889 3.19532 3.88889 2.57736 4.20376C2.03377 4.48072 1.59183 4.92266 1.31487 5.46625C1 6.08421 1 6.89317 1 8.51111V22.3778C1 23.9957 1 24.8047 1.31487 25.4227C1.59183 25.9662 2.03377 26.4082 2.57736 26.6851C3.19532 27 4.00429 27 5.62222 27Z",
    stroke: "#104145",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconGreen);
export default __webpack_public_path__ + "static/media/calendar-icon-green.d5f3f417a6143372e0164c69455f554d.svg";
export { ForwardRef as ReactComponent };